import {useEffect, useState} from 'react';
import { Auth} from 'aws-amplify';

function AuthDebug() {

	const [user, setUser] = useState(null);

	useEffect(() => {
    	getUser().then(userData => setUser(userData));
  	}, []);

	function getUser() {
    	return Auth.currentAuthenticatedUser()
    	.then(userData => userData)
    	.catch(() => console.log('Not signed in'));
  	}
    
    return (
        <pre>
            {JSON.stringify(user, null, 2)}
        </pre>
    );
}

export default AuthDebug;